import { connect, useDispatch } from "react-redux";
import { hideModal } from "../../../../../store/actions/modal";
import Modal from "../../../../../components/Modal";

import {
  Actions,
  Title,
  Subtitle,
  Text,
  List,
  ListItem,
  CopyButton,
  CloseButton,
} from "./styles";

const Component = ({ }) => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(hideModal());
  };

  const handleCopyTemplate = async () => {
    const emailTemplate = `Template EMAIL

Asunto: Solicitud de aumento de límite para suscripciones

Hola equipo de Mercado Pago,

Soy <NOMBRE COMPLETO>, seller activo de Mercado Pago Subscriptions a través de una integración con Klouser (https://klouser.app/).

Quisiera solicitar el aumento del límite por suscripción. El tope actual de $250.000 ARS quedó desactualizado y necesitamos habilitar planes semestrales o anuales con importes superiores. Esto impacta directamente en nuestro crecimiento y en el volumen que Mercado Pago podría procesar.

Solicito, por favor, elevar el límite de suscripción para mi cuenta (<MAIL DE LA CUENTA DE MP>) a fin de operar planes mayores a $250.000 ARS.

Quedo atento/a a los próximos pasos.

Saludos cordiales,
<NOMBRE>
<DNI / CUIT (opcional)>
<Teléfono (opcional)>`;

    try {
      await navigator.clipboard.writeText(emailTemplate);
      // You could add a toast notification here if needed
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };


  return (
    <>
      <Modal
        width="480"
        name="mp-250k-modal"
        onClose={() => handleCancel()}
        styles={{
          modalContent: {
            padding: "24px 40px"
          }
        }}
      >
        <Title>Activá planes mayores a $250.000 en Mercado Pago</Title>

        <div style={{ height: 8 }} />

        <Text>El aumento del límite debe gestionarlo el seller (titular de la cuenta).</Text>
        <Text><b>¿Por qué?</b></Text>
        <Text>Mercado Pago tiene un límite histórico de $250.000 por suscripción. Para planes semestrales o anuales o precios superiores, Mercado Pago debe elevar tu límite en tu cuenta.</Text>

        <Text><b>Qué tenés que hacer (3 pasos):</b></Text>

        <List>
          <ListItem>Escribí a soporte por WhatsApp desde tu cuenta de Mercado Pago.</ListItem>
          <ListItem>Pedí hablar con un asesor de cuentas para aumentar el límite de suscripción.</ListItem>
          <ListItem>Enviá el email de solicitud (te dejamos un modelo listItemo para copiar).</ListItem>
        </List>

        <Text>El tiempo de respuesta puede variar según el volumen procesado de cada cuenta (Mercado Pago prioriza caso por caso).</Text>

        <Text>Te compartimos un modelo de email para que puedas copiar y enviar a soporte de Mercado Pago.</Text>


        <Actions>
          <CopyButton
            type="button"
            onClick={handleCopyTemplate}
            options={{
              skin: "purple",
              size: "lg",
              type: "filled",
            }}
          >
            Copiar e-mail
          </CopyButton>
          <CloseButton
            type="button"
            onClick={handleCancel}
            options={{
              skin: "purple",
              size: "lg",
              type: "outline",
            }}
          >
            Cerrar
          </CloseButton>
        </Actions>
      </Modal>
    </>
  );
};


const state = ({ userStore }) => {
  const { states: changeUserAvatarStates } = userStore.changeUserAvatar;
  return {
    changeUserAvatarStates,
  };
};

export default connect(state)(Component);
